import React from 'react';
interface AppButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean;
}
export function AppButton({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: AppButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none disabled:opacity-35 disabled:cursor-not-allowed';
  const variantClasses: Record<ButtonVariant, string> = {
    primary: 'bg-[#2A3B5C] text-white font-heading uppercase tracking-wide hover:bg-[#1E2A40] active:bg-[#151D2C]',
    secondary: 'bg-gray-100 text-gray-700 border border-gray-200 hover:bg-gray-200 hover:border-gray-300',
    ghost: 'text-gray-500 hover:text-gray-900 hover:bg-gray-100',
    danger: 'bg-red-50 text-red-600 border border-red-100 hover:bg-red-100',
    outline: 'bg-transparent text-gray-700 border border-gray-300 hover:bg-gray-50'
  };
  const sizeClasses: Record<ButtonSize, string> = {
    sm: 'px-4 py-2 text-xs rounded-md',
    md: 'px-6 py-3 text-[15px] rounded-md',
    lg: 'px-8 py-4 text-base rounded-md'
  };
  return <button className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${fullWidth ? 'w-full' : ''} ${className}`} disabled={disabled} {...props} data-id="element-53">
      {icon && iconPosition === 'left' && <span className="mr-2 opacity-60" data-id="element-54">{icon}</span>}
      {children}
      {icon && iconPosition === 'right' && <span className="ml-2 opacity-60" data-id="element-55">{icon}</span>}
    </button>;
}